import { EventRecordFilterSchema, FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
import '../../../modules/companies/register-panels'
import { CompaniesView } from '../../../modules/companies/companies-view'

const companiesSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
  q: z.string().optional(),
  page: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  // AND/OR filter expression (Unit B: filter state lives in the URL, Zod-validated).
  filter: FilterExprSchema.optional(),
  // Quick-filter values (the top-bar chips), URL-backed + Zod-validated.
  quick: FilterExprSchema.optional(),
  // "Did event X in the last N days" record filter (honored server-side by company.list).
  eventFilter: EventRecordFilterSchema.optional(),
})

/** The standard companies list. Search/sort/panel state lives in the URL. */
export const Route = createFileRoute('/_authed/companies/')({
  validateSearch: companiesSearchSchema,
  component: CompaniesRoute,
})

function CompaniesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <CompaniesView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
